<template>
  <cube-button-group>
    <cube-button primary>确认按钮</cube-button>
  </cube-button-group>
</template>

<script>
  import { createComponent } from '@mpxjs/core'

  createComponent({})
</script>

<script type="application/json">
  {
    "usingComponents": {
      "view-desc": "../../components/desc/index",
      "cube-button-group": "@mpxjs/mpx-cube-ui/src/components/button-group/index",
      "cube-button": "@mpxjs/mpx-cube-ui/src/components/button/index"
    }
  }
</script>
